import { createWithEqualityFn as create } from 'zustand/traditional';

export interface FacetListStateValues {
  activeFacet?: string;
}

export interface FacetListStateActions {
  setActiveFacet(id?: string): void;
}

export interface FacetListState extends FacetListStateValues, FacetListStateActions {}

const defaultState: FacetListStateValues = {};

export const useFacetListState = create<FacetListState>()((set) => ({
  ...defaultState,
  setActiveFacet: (value) => set({ activeFacet: value }),
}));
